(function () {
  if (window.__ewLoaded) return;

  var consentMatch = document.cookie.match(/(?:^|;\s*)OptanonConsent=([^;]*)/);
  if (!consentMatch) return;

  var consentValue = "";
  try {
    consentValue = decodeURIComponent(consentMatch[1]);
  } catch (error) {
    consentValue = consentMatch[1];
  }

  if (consentValue.indexOf("C0003:1") === -1) return;
  window.__ewLoaded = true;

  function getLangCandidate() {
    var htmlLang = (document.documentElement && document.documentElement.getAttribute('lang')) || '';
    if (htmlLang) return htmlLang;

    var seg = (location.pathname || '').split('/').filter(Boolean)[0] || '';
    if (seg) return seg;

    return (navigator.language || navigator.userLanguage || 'en');
  }

  function normalizeCandidate(c) {
    return String(c || '')
      .trim()
      .replace('_', '-')
      .toLowerCase();
  }

  function toMenulang(candidate) {
    var c = normalizeCandidate(candidate);
    var parts = c.split('-').filter(Boolean);
    var lang = parts[0] || 'en';
    var region = parts[1] || '';

    var map = {
      en: 'EN',
      de: 'DE',
      nl: 'NL',
      fr: 'FR',
      es: 'ES',
      pt: 'PT-PT',
      it: 'IT',
      pl: 'PL',
      ro: 'RO',
      bg: 'BG',
      hr: 'HR',
      no: 'NB',
      nb: 'NB',
      sv: 'SV',
      se: 'SV'
    };

    if (lang === 'en' && region) {
      var r = region.toUpperCase();
      if (r === 'GB') return 'EN-GB';
      if (r === 'CA') return 'EN-CA';
      if (r === 'AU') return 'EN-AU';
      if (r === 'ZA') return 'EN-ZA';
      return 'EN';
    }

    if (lang === 'pt' && region) {
      var pr = region.toUpperCase();
      if (pr === 'BR') return 'PT';
      if (pr === 'PT') return 'PT-PT';
      return 'PT-PT';
    }

    return map[lang] || 'EN';
  }

  window.interdeal = {
    sitekey: "b9f3929bc430ea2b8d4d204e97d1abdc",
    domains: {
      js: "https://cdn.equalweb.com/",
      acc: "https://access.equalweb.com/"
    },
    Position: "left",
    Menulang: toMenulang(getLangCandidate()),
    draggable: true,
    btnStyle: {
      vPosition: ["80%", "80%"],
      margin: ["0", "0"],
      scale: ["0.6", "0.6"],
      color: { main: "#eb3986", second: "#ffffff" },
      icon: { outline: false, outlineColor: "#ffffff", type: 11, shape: "circle" }
    }
  };

  var s = document.createElement("script");
  s.src = "https://cdn.equalweb.com/core/5.1.1/accessibility.js";
  s.async = true;
  s.defer = true;
  s.crossOrigin = "anonymous";
  s.setAttribute("data-cfasync", "true");
  document.head.appendChild(s);
})();
